import { useContext, useState } from "react";
import ConfirmModal from "../../../../components/modalWindow/confirmModal";
import Modal from "../../../../components/modalWindow/modal";
import { CancelTaskWindowProps } from "./types/cancelTaskWindowProps";
import { ReactComponent as CancelIcon } from '../../../../icons/cancel.svg';
import { ObjectType } from "../../../../contexts/types/card";
import InfoModal from "../../../../components/modalWindow/infoModal";
import Chip from "../../../../components/shared/chip/chip";
import { cancelTask } from "../../../../services/mainDatabaseService/mainDatabaseService";
import { CancelTaskProps, CancelTaskResponse, CancelTaskType } from "../../../../services/mainDatabaseService/types/mainDatabaseServiceProps";
import { apiContext } from "../../../../contexts/apiContext";
import { notifyError } from "../../../../components/snackbar/snackbar";
import { classNameBtn } from "../../../../components/shared/button/types/buttonProps";
import ButtonField from "../../../../components/buttonField/buttonField";
import "./cancelTaskWindow.scss";
import Summary from "../../../../components/summary/summary";
import { ProcessMarker } from "../types/tasklListViewProps";

const CancelTaskWindow = (props: CancelTaskWindowProps) => {
    const api = useContext(apiContext);
    const [confirmation, setConfirmation] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [summary, setSummary] = useState<CancelTaskResponse | null>(null);

    const getOAndK = () => {
        return props.rows
            .filter(row => {
                var attr = row.original.attributes;
                return attr.ZNACZNIK_PROCESU_DOM === ProcessMarker.O || attr.ZNACZNIK_PROCESU_DOM === ProcessMarker.K
                    || attr.RODZAJ_OBIEKTU === ObjectType.POO || attr.RODZAJ_OBIEKTU === ObjectType.POTZ;
            })
            .map(row => row.original.attributes);
    }

    const getAAndN = () => {
        return props.rows
            .filter(row => {
                var attr = row.original.attributes;
                return attr.ZNACZNIK_PROCESU_DOM === ProcessMarker.A || attr.ZNACZNIK_PROCESU_DOM === ProcessMarker.N
                    || attr.RODZAJ_OBIEKTU === ObjectType.POO || attr.RODZAJ_OBIEKTU === ObjectType.POTZ;
            })
            .map(row => row.original.attributes);
    }

    const confirm = () => {
        setConfirmation(false);
        setLoading(true);

        const accepted = getData().map(a => Number(a.ID));
        let cancelProps: CancelTaskProps = {
            ids: accepted,
            apiBase: api.apiUrl + api.apiVersion,
            type: props.type
        };

        cancelTask(cancelProps)
            .then((response: CancelTaskResponse) => {
                setSummary(response);
                setLoading(false);
            })
            .catch(() => {
                notifyError({ message: "Próba anulowania zadań zakończona niepowodzeniem" });
                props.onClose();
            });
    }

    const close = () => {
        if (!loading) {
            props.onClose(false);
        }
        if (summary !== null) {
            props.reload();
        }
    }

    const cancelClose = () => {
        if (!loading) {
            props.onClose(true);
        }
    }

    const question = (accepted: any[]) => {
        if (accepted.length === props.rows.length) {
            return "Czy chcesz anulować zadania edycji dla wybranych kart?"
        }
        return <div>
            <div>Czy chcesz anulować zadania edycji dla kart, dla których operacja może zostać wykonana?</div>
            <div className="cancelTask-cards">
                {accepted.map(a => {
                    return <div className="cancelTask-tag"><Chip key={a.ID} title={a.NUMER_IDENTYFIKACYJNY} /></div>
                })}
            </div>
        </div>
    }

    const getData = () => {
        return props.type === CancelTaskType.OK ? getOAndK() : getAAndN()
    }

    if (confirmation) {
        const accepted = getData();
        if (accepted.length === 0) {
            return (<InfoModal width={"660px"} height={"auto"}
                cancelTitle={"Zamknij"}
                onCancel={cancelClose}
                information="Brak możliwości anulowania wybranych zadań."
            />)
        } else {
            return (
                <ConfirmModal width={"660px"} height={"auto"}
                    confirmTitle={"Tak, anuluj karty"}
                    onConfirm={confirm}
                    cancelTitle={"Rezygnuj"}
                    onCancel={cancelClose}
                    question={question(accepted)}
                />)
        }
    }

    return (
        <>
            <Modal
                title={props.type === CancelTaskType.OK ? "Anulowanie zadania edycji (proces O i K)" : "Anulowanie zadania (proces A i N)"}
                titleIcon={CancelIcon}
                iconClass='titleIconBlack'
                width={'100%'}
                height={'50vh'}
                actionBtns={summary !== null ? [
                    <ButtonField
                        key={1}
                        BtnProps={{
                            onClick: close,
                            className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium`
                        }}
                        placeHolder="Zamknij"
                    />
                ] : []}
                onClose={close}>
                <Summary loading={loading} summary={summary} />
            </Modal>
        </>);
}

export default CancelTaskWindow;